<template>
  <div>
    <b-navbar class="navbar position-absolute" toggleable="lg">
      <b-navbar-brand href="/"><img class="navbar-brand-img" :src="getLogo" /></b-navbar-brand>
      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav class="ml-auto">
          <b-nav-item class="my-auto" @click="$router.push('/abogados')">{{ $t('openlegal.menu.are-you-lawyer')}}</b-nav-item>
          <b-nav-item class="my-auto" @click="$router.push('/openlegal360/empresas')">{{ $t('openlegal.menu.business')}}</b-nav-item>
          <b-nav-item class="my-auto mr-0 mr-md-5" href="https://blog.opensalud.es/">Blog</b-nav-item>
          <b-nav-item class="my-auto nav-lang">
            <lang-selector class="d-inline-block pt-lg-0 pt-3 pb-lg-0 pb-2 mr-0"></lang-selector>
          </b-nav-item> 
          <span style="display: contents">
            <!-- <b-nav-item>
              <base-button blue outline @click="() => { signUpVisible = true }"><span>{{ $t('sign-up') }}</span>
              </base-button>
            </b-nav-item> -->
          <b-nav-item> 
              <base-button blue @click="$router.push('/inicio-sesion')"><span>{{ $t('openlegal.menu.sign-in') }}</span>
                <base-icon src="/static-appopensalud/img/icons/morillas-svg-icons/primary/arrow.svg" class="ml-2"
                  :color="$uiHelpers.isMobile ? ORANGE_COLOUR : 'white'" />
              </base-button>
            </b-nav-item> 
          </span> 
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
    <openlegal-search-block></openlegal-search-block>
    <openlegal-cards-slider-home></openlegal-cards-slider-home>
    <b-row id="lawyers-block" class="section-invert py-0 my-lg-5 my-0">
      <b-col md="12" lg="6" class="my-auto content">
        <h3>{{ $t('openlegal.are-you-lawyer') }}</h3>
        <div class="subtitle">
          <div class="logo-block mt-5">
            <p>{{ $t('openlegal.lawyer-block-description') }}</p>
            <p class="d-inline-block">{{ $t('openlegal.sign-up-in')}}</p><img class="d-inline-block ml-2 mb-3"
              src="/static-appopensalud/img/logos/openlegalpro_white.svg" />
          </div>
        </div>
        <br>
        <base-button @click="$helpers.goToSection('contact-form')" white outline class="mt-5">{{ $t('openlegal.menu.sign-in')}}</base-button>
      </b-col>
      <b-col md="12" lg="6" class="py-0 py-lg-5 bg-reduced">
        <div class="col-bg ml-lg-auto">
        </div>
      </b-col>
    </b-row>
    <b-row id="security-data" class="section reverse-sm">
      <b-col md="12" lg="6" class="pr-5">
        <div class="col-bg ml-lg-auto">
        </div>
      </b-col>
      <b-col md="12" lg="6" class="content my-auto pl-0 pl-md-5">
        <h3 style="font-weight:bold">{{ $t('openlegal.security-privacity') }}</h3>
        <h5 class="p-0">{{ $t('openlegal.security-subtitle') }}</h5>
        <div class="subtitle">
          <p>{{ $t('openlegal.security-text1') }}</p>
        </div>
        <div class="subtitle" style="margin-bottom:7rem;">
          <p>{{ $t('openlegal.security-text2') }}</p>
        </div>
        <b-row style="display:initial;" class="cert-icons">
          <div style="display:inline-block">
						<ISO27001Logo/>
          </div>
          <div style="display:inline-block">
            <img class="vertical" src="/static-appopensalud/img/icons/morillas-svg-icons/Logo/iso.png" />
          </div>
        </b-row>
      </b-col>
    </b-row>
    <openlegal-video-service></openlegal-video-service>
    <companies-contact-form id="contact-form" :title="$t('openlegal.explain-case')" showDescription :subtitle="$t('openlegal.contact-form.text')" :serviceType="$t('legal-services')" forIndividualsOnly platform="Openlegal" productName="Openlegal" class="pb-5 pb-md-0"></companies-contact-form>
  </div>
</template>

<script>
import { BNavbar, BNavbarNav, BNavbarBrand, BNavbarToggle, BCollapse, BNavItem } from 'bootstrap-vue'
import LangSelector from '../../base/LangSelector.vue'
import CompaniesContactForm from '@/components/forms/CompaniesContactForm.vue'
import NeuCardsSlider from '@/components/base/ui/NeuCardsSlider'
import OpenlegalSearchBlock from './OpenlegalSearchBlock.vue'
import OpenlegalCardsSliderHome from './OpenlegalCardsSliderHome.vue'
import layoutMixin from '@/mixins/layout.mixin'
import OpenlegalVideoService from './OpenlegalVideoService.vue'
import { ORANGE_COLOUR } from '@/constants/colours'
import ISO27001Logo from '@/components/utils/ISO27001Logo.vue'

export default {
  components: {
    BNavbar,
    BNavbarNav,
    BNavbarBrand,
    BNavbarToggle,
    BNavItem,
    BCollapse,
    LangSelector,
    CompaniesContactForm,
    NeuCardsSlider,
    OpenlegalSearchBlock,
    OpenlegalCardsSliderHome,
    OpenlegalVideoService,
		ISO27001Logo
  },
  mixins: [
    layoutMixin
  ],
	data () {
		return {
			ORANGE_COLOUR
		}
	}
}
</script>

<style lang="scss">
  @import "static-appopensalud/css/public/views/openlegal.scss";
	
  .bg-reduced {
    @include desktop () {
      padding-right: 10rem !important;
      padding-left: 10rem !important;
    }
  }

  #lawyers-block {
    .col-bg {
      background-image: url('/static-appopensalud/img/bgs/openlegal/law-firm-marketing.jpg');
      background-size: cover;
      background-position-x: center;
    }
  }

  /deep/.cert-icons {
    div {
      margin: {
        top: auto;
        bottom: auto;
        right: 4rem;
      }
      @include media(tablets, mobile) {
        padding: {
          top: 1rem;
          bottom: 1rem;
        }
      }

      display: flex;
      img {
        margin: auto;
        float: left;
        &.vertical {
          @include desktop {
            height: 9rem;
          }
          @include desktop-sm {
            height: 9rem;
          }
          @include tablets {
            height: 6rem;
          }
          @include mobile {
            height: 7rem;
          }
        }
        &:not(.vertical) {
          width: 120px;
          @include mobile {
            width: 100px;
          }
        }

        object-fit: cover;
      }
    }
  }

  #security-data {
    h3 {
      @include desktop(){
        font-size: 3rem !important;
      }
      @include desktop-sm(){
        font-size: 3rem !important;
      }
      @include mobile(){
        font-size: 25px !important;
      }
    }
  .col-bg {
    background-blend-mode: overlay;
    background-image: url('/static-appopensalud/img/bgs/opt/privacity.jpg');
    @include mobile {
      display: none;
    }
    @include tablets {
      display: none;
    }
  }

  .subtitle {
    p {
      font-weight: initial;
    }
  }
}

.navbar-toggler-icon {
  background-image: url('/static-appopensalud/img/icons/morillas-svg-icons/primary/hamburguer-orange.svg') !important;
}
</style>


// WEBPACK FOOTER //
// src/components/views/openlegal/Home.vue